export default {
  title: '面试管理',
  tab: '面试管理'
}
